// extracted by mini-css-extract-plugin
export default {"header":"vC","discountBanner":"wC","logo":"xC","maincontainer":"yC","videocontainer":"zC","videowelcome":"AC","videowrapper":"BC","videosale":"CC","loadingcontainer":"EC","footer":"FC","footerbutton":"GC","video":"HC","logoname":"IC"};
    if(module.hot) {
      // 1714422956203
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  